import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'cz', label: 'Čeština', flag: '🇨🇿' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const LangSwitch = () => {
  const { i18n , t} = useTranslation();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setOpen(!open);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  // Close menu if clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentLang = languages.find((lang) =>
    i18n.language.startsWith(lang.code)
  ) || languages[0]; // default fallback

  return (
    <div ref={menuRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button class="cursor-pointer ml-3" onClick={toggleMenu} style={{ fontSize: '1.5rem'}}>
        {currentLang.flag}
      </button>

      {open && (
        <div 
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            padding: '0.5rem',
            zIndex: 100,
          }}
        >
          {languages.map((lang) => (
            <div  class={"cursor-pointer flex items-center px-2 py-1 my-1 mx-2 hover:bg-orange-200 rounded-lg"} key={lang.code} onClick={() => changeLanguage(lang.code)}>
              <span class="mr-3">{lang.flag}</span> {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangSwitch;